import React from "react";
import { Card } from "../components/ui/card";

const STAGES = [
  { key: "sponsor_review", label: "Broker Review" },
  { key: "submitted_to_admin", label: "Submitted to Admin" },
  { key: "ok_to_apply", label: "OK to Apply" },
  { key: "application_sent", label: "Application Sent" },
  { key: "approved", label: "Approved" },
];

export default function PipelineSummary({ pipeline = {}, extraStages = [] }) {
  const stages = [...STAGES, ...extraStages];
  const max = Math.max(1, ...stages.map((s) => Number(pipeline[s.key] || 0)));
  return (
    <Card className="border-slate-800 bg-slate-900 p-5" data-testid="pipeline-summary-card">
      <div className="mb-4 flex items-baseline justify-between">
        <div className="text-sm font-semibold text-slate-100">Application Pipeline</div>
        <div className="text-[11px] uppercase tracking-wider text-slate-500">Stage → Count</div>
      </div>
      <div className="space-y-3">
        {stages.map((s) => {
          const count = Number(pipeline[s.key] || 0);
          const pct = (count / max) * 100;
          return (
            <div key={s.key} data-testid={`pipeline-stage-${s.key}`}>
              <div className="mb-1 flex items-center justify-between text-xs">
                <span className="text-slate-300">{s.label}</span>
                <span className="tabular-nums font-medium text-slate-100">{count}</span>
              </div>
              <div className="h-1.5 overflow-hidden rounded-full bg-slate-800">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-emerald-400 transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
